<template>
  <div>
    <el-form :model="form" :rules="rules" ref="dataForm" label-width="120px" class="demo-ruleForm">
      <el-row>
        <el-col :span="16">
          <el-form-item label="设备名称：" prop="sparePartsName">
            <el-input v-model="form.sparePartsName" :maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供货码：" prop="supplyCode">
            <el-input v-model="form.supplyCode" :maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备件描述：" prop="demand">
            <el-input type="textarea" v-model="form.demand" :maxlength="400" :rows="4" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="规格型号：" prop="model">
            <el-input v-model="form.model" :maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="配置：" prop="config">
            <el-input v-model="form.config" :maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="价格：" prop="price">
            <el-input-number v-model="form.price"
                           class="priceInput"
                           style="width:100%;"
                           :controls="false"
                           :min="0"
                           :max="9999999999"
                           :step="1"
                           :precision="2"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应数量：" prop="supplyNum">
            <el-input v-model="form.supplyNum" placeholder="请输入" :maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="新旧程度：" prop="isNew">
            <el-select v-model="form.isNew" placeholder="请选择">
              <el-option
                v-for="item in isNewList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="备件品牌：" prop="brand">
            <el-input v-model="form.brand" :maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="备件发货地：" prop="address">
            <el-select v-if="provinceList" v-model="form.provinceId" placeholder="请选择省" @change="handleProvinceChoose" style="width: 160px;margin-right: 20px;">
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.name"
                :value="`${item.codeP}`">
              </el-option>
            </el-select>
            <el-select :disabled="!form.province" v-model="form.cityId" placeholder="请选择市" @change="handleCityChoose" style="width: 160px;margin-right: 20px;">
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.name"
                :value="`${item.codeC}`">
              </el-option>
            </el-select>
            <el-select :disabled="!form.city" v-model="form.areaId" placeholder="请选择区" @change="handleAreaChoose" style="width: 160px;">
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.name"
                :value="`${item.codeA}`">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="建档时间：" prop="name">
            <span>{{form.createTime}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="建档人：" prop="name">
            <span>{{form.createUser}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="更新时间：" prop="name">
            <span>{{form.modifyTime}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="更新人：" prop="name">
            <span>{{form.modifyUser}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'defaultInfo', // 基础信息
  data () {
    var validatePrice = (rule, value, callback) => {
      if (Number(value) === 0) {
        callback(new Error('价格不能小于等于0'))
      } else {
        if (!Number(value)) {
          callback(new Error('请输入数字'))
        } else {
          if (value <= 0) {
            callback(new Error('价格不能小于等于0'))
          } else {
            callback()
          }
        }
      }
    }
    const validateSupplyNum = (rule, value, callback) => {
      if (value && !(/^[1-9]([0-9])*$/.test(value))) {
        callback(new Error('只能输入正整数'))
      } else {
        callback()
      }
    }
    const validateAddress = (rule, value, callback) => {
      if (!this.form.province) {
        callback(new Error('省份不能为空'))
      } else if (!this.form.city) {
        callback(new Error('市不能为空'))
      } else if (!this.form.area) {
        callback(new Error('区域不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        sparePartsName: '',
        supplyCode: '',
        demand: '',
        model: '',
        config: '',
        price: '',
        supplyNum: '',
        brand: '',
        province: '',
        city: '',
        area: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        address: '',
        isNew: '1'
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      isNewList: [
        {
          value: '1',
          label: '全新'
        }, {
          value: '2',
          label: '非全新'
        }
      ],
      rules: {
        sparePartsName: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        supplyCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        isNew: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        model: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        supplyNum: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          },
          { validator: validateSupplyNum, trigger: 'blur' }
        ],
        price: [
          {
            required: true,
            message: '价格不能为空且只能为数字',
            trigger: 'blur'
          },
          { validator: validatePrice, trigger: 'blur' }
        ],
        brand: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          },
          { validator: validateAddress, trigger: 'change' }
        ]
      },
      options: []
    }
  },
  methods: {
    // 选中省
    handleProvinceChoose (value) {
      // this.form.province = value.slice(0, this.province.indexOf('%'))
      // this.codeP = value.slice(this.province.indexOf('%') + 1)
      // this.city = ''
      this.cityList = null
      // this.area = ''
      this.areaList = null
      this.form.province = this.provinceList.filter(item => {
        return item.codeP === value
      })[0].name
      this.form.area = ''
      this.form.city = ''
      this.form.areaId = ''
      this.form.cityId = ''
      // this.codeC = ''
      // this.codeA = ''
      this.getCity()
    },
    // 选中市
    handleCityChoose (value) {
      // this.form.city = this.city.slice(0, this.city.indexOf('%'))
      // this.codeC = this.city.slice(this.city.indexOf('%') + 1)
      // this.area = ''
      this.areaList = null
      this.form.area = ''
      this.form.areaId = ''
      this.form.city = this.cityList.filter(item => {
        return item.codeC === value
      })[0].name
      // this.codeA = ''
      this.getArea()
    },
    // 选中区
    handleAreaChoose (value) {
      this.form.address = value
      this.form.area = this.areaList.filter(item => {
        return item.codeA === value
      })[0].name
      // this.form.area = this.area.slice(0, this.area.indexOf('%'))
      // this.codeA = this.area.slice(this.area.indexOf('%') + 1)
    },
    // 获取省列表
    getProvince (edit) {
      this.$http.post(`/help/sys/sysProvince/queryList`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.provinceList = data.data
            if (edit) {
              this.provinceList.forEach(item => {
                if (item.name === this.form.province) {
                  this.form.provinceId = item.codeP
                }
              })
              this.getCity(true)
            }
          }
        })
        .catch(() => {
          this.provinceList = []
        })
    },
    // 获取市列表
    getCity (edit) {
      this.$http.post(`/help/sys/sysCity/queryList`, {
        codeP: this.form.provinceId
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.cityList = data.data
            if (edit) {
              this.cityList.forEach(item => {
                if (item.name === this.form.city) {
                  this.form.cityId = item.codeC
                }
              })
              this.getArea(true)
            }
          }
        })
        .catch(() => {
          this.cityList = []
        })
    },
    // 获取区列表
    getArea (edit) {
      this.$http.post(`/help/sys/sysArea/queryList`, {
        codeC: this.form.cityId
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.areaList = data.data
            if (edit) {
              this.areaList.forEach(item => {
                if (item.name === this.form.area) {
                  this.form.areaId = item.codeA
                  this.form.address = this.form.area
                }
              })
            }
          }
        })
        .catch(() => {
        })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('基础信息填写不正确！'))
          }
        })
      })
    },
    setDataForm (data) {
      this.form.sparePartsName = data.sparePartsName
      this.form.supplyCode = data.supplyCode
      this.form.demand = data.demand
      this.form.model = data.model
      this.form.config = data.config
      this.form.price = data.price
      this.form.supplyNum = data.supplyNum
      this.form.province = data.province
      this.form.city = data.city
      this.form.area = data.area
      this.form.isNew = data.isNew
      // this.form.address = data.area
      this.getProvince(true)
      this.form.createTime = data.createTime
      this.form.createUser = data.createUser
      this.form.modifyTime = data.modifyTime
      this.form.modifyUser = data.modifyUser
      this.form.brand = data.brand
      this.form.sparePartsId = data.sparePartsId
    },
    getDataForm () {
      let data = Object.assign({}, this.form)
      delete data.createTime
      delete data.createUser
      delete data.modifyTime
      delete data.modifyUser
      return data
    },
    init () {
      this.getProvince()
    },
    resetDataForm () {
      this.form.isNew = '1'
      this.form.createTime = ''
      this.form.createUser = ''
      this.form.modifyTime = ''
      this.form.modifyUser = ''
      this.form.province = ''
      this.form.city = ''
      this.form.area = ''
      this.form.provinceId = ''
      this.form.cityId = ''
      this.form.areaId = ''
      this.form.address = ''
      this.$refs['dataForm'].resetFields()
      delete this.form.sparePartsId
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
.priceInput {
  /deep/ .el-input__inner {
    text-align: right;
  }
}
</style>
